// import React from "react";
// import {
//   SummaryPeriod,
//   useFetchMerchantCODGraph,
// } from "../../../apis/dashboardApis";

// type ChartItem = {
//   label: string;
//   value: number;
//   color?: string;
// };

// const colors = [
//   "#8B5CF6",
//   "#F59E0B",
//   "#F97316",
//   "#3B82F6",
//   "#22C55E",
//   "#EF4444",
//   "#EC4899",
//   "#14B8A6",
//   "#6366F1",
//   "#EAB308",
//   "#06B6D4",
//   "#84CC16",
//   "#F43F5E",
//   "#A855F7",
//   "#10B981",
// ];

// const radius = 90;
// const strokeWidth = 28;
// const normalizedRadius = radius - strokeWidth / 2;
// const circumference = normalizedRadius * 2 * Math.PI;

// type CodByMarchentProps = {
//   summaryType?: SummaryPeriod;
//   startDate?: string;
//   endDate?: string;
// };

// const CodByMarchent: React.FC<CodByMarchentProps> = ({
//   summaryType,
//   startDate,
//   endDate,
// }) => {
//   const { data: merchantCODData } = useFetchMerchantCODGraph({
//     type: summaryType ?? "Today",
//     startDate,
//     endDate,
//     limit: 10,
//   });

//   const data: ChartItem[] =
//     merchantCODData?.map((item: any, index: number) => ({
//       label: item.clientName ?? "Unknown",
//       value: Number(item.codOrders) || 0,
//       color: colors[index % colors.length],
//     })) ?? [];

//   const total = data.reduce((acc, item) => acc + item.value, 0);
//   const chartData =
//     total > 0 ? data : [{ label: "No COD", value: 1, color: "#D2D2D2" }];

//   let cumulativePercent = 0;

//   return (
//     <div className="w-full rounded-3xl bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] px-6 py-7">
//       {/* Header */}
//       <div className="mb-6 flex items-center justify-between">
//         <h2 className="text-xl font-semibold text-[#212121]">
//           COD By Merchant
//         </h2>
//       </div>

//       {/* Content */}
//       <div className="flex flex-col items-center justify-center gap-10 md:flex-row">
//         {/* Donut Chart */}
//         <div className="relative flex items-center justify-center">
//           <svg height={radius * 2} width={radius * 2} className="-rotate-90">
//             {chartData.map((item, index) => {
//               const percent = item.value / (total || 1);

//               const strokeDasharray = `${
//                 percent * circumference
//               } ${circumference}`;

//               const strokeDashoffset =
//                 -cumulativePercent * circumference;

//               cumulativePercent += percent;

//               return (
//                 <circle
//                   key={index}
//                   stroke={item.color}
//                   fill="transparent"
//                   strokeWidth={strokeWidth}
//                   strokeDasharray={strokeDasharray}
//                   strokeDashoffset={strokeDashoffset}
//                   r={normalizedRadius}
//                   cx={radius}
//                   cy={radius}
//                 />
//               );
//             })}
//           </svg>

//           {/* Center Circle */}
//           <div className="absolute flex h-28 w-28 flex-col items-center justify-center rounded-full bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] text-center">
//             <span className="text-xs text-[#212121]/60">Total COD</span>
//             <span className="text-2xl font-semibold text-[#212121]">
//               {total.toLocaleString()}
//             </span>
//           </div>
//         </div>

//         {/* Legend */}
//         <div className="space-y-1.5">
//           {data.map((item, index) => (
//             <div key={index} className="flex items-center gap-3">
//               <div
//                 className="h-3 w-3 rounded-full"
//                 style={{ backgroundColor: item.color }}
//               />

//               <span className="min-w-28 truncate text-sm text-[#212121]">
//                 {item.label}
//               </span>
//               <span className="text-sm font-medium text-[#212121]">
//                 {item.value.toLocaleString()}
//               </span>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CodByMarchent;

/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React from "react";
import {
  SummaryPeriod,
  useFetchMerchantCODGraph,
} from "../../../apis/dashboardApis";

type ChartItem = {
  label: string;
  value: number;
  color?: string;
};

const colors = [
  "#8B5CF6",
  "#F59E0B",
  "#F97316",
  "#3B82F6",
  "#22C55E",
  "#EF4444",
  "#EC4899",
  "#14B8A6",
  "#6366F1",
  "#EAB308",
  "#06B6D4",
  "#84CC16",
  "#F43F5E",
  "#A855F7",
  "#10B981",
];

const radius = 95;
const strokeWidth = 24;
const normalizedRadius = radius - strokeWidth / 2;
const circumference = normalizedRadius * 2 * Math.PI;

type CodByMarchentProps = {
  summaryType?: SummaryPeriod;
  startDate?: string;
  endDate?: string;
};

const CodByMarchent: React.FC<CodByMarchentProps> = ({
  summaryType,
  startDate,
  endDate,
}) => {
  const { data: merchantCODData } = useFetchMerchantCODGraph({
    type: summaryType ?? "Today",
    startDate,
    endDate,
    limit: 10,
  });

  const data: ChartItem[] =
    merchantCODData?.map((item: any, index: number) => ({
      label: item.clientName ?? "Unknown",
      value: Number(item.codOrders) || 0,
      color: colors[index % colors.length],
    })) ?? [];

  const total = data.reduce((acc, item) => acc + item.value, 0);

  const chartData =
    total > 0
      ? data
      : [
          {
            label: "No COD",
            value: 1,
            color: "#D1D5DB",
          },
        ];

  let cumulativePercent = 0;

  return (
    <div className="h-full rounded-[28px] border border-[#ECECEC] bg-white p-6 shadow-sm">
      {/* Header */}
      <div className="mb-8">
        <h2 className="text-xl font-semibold text-[#111827]">
          COD By Merchant
        </h2>

        <p className="mt-1 text-sm text-[#6B7280]">
          Merchant-wise COD analytics
        </p>
      </div>

      {/* Content */}
      <div className="flex w-full items-center">
        {/* Donut Chart */}
        <div className="relative mb-10 flex items-center justify-center w-full">
          <svg height={radius * 2} width={radius * 2} className="-rotate-90">
            {/* Background */}
            <circle
              stroke="#F3F4F6"
              fill="transparent"
              strokeWidth={strokeWidth}
              r={normalizedRadius}
              cx={radius}
              cy={radius}
            />

            {chartData.map((item, index) => {
              const percent = item.value / (total || 1);

              const strokeDasharray = `${
                percent * circumference
              } ${circumference}`;

              const strokeDashoffset = -cumulativePercent * circumference;

              cumulativePercent += percent;

              return (
                <circle
                  key={index}
                  stroke={item.color}
                  fill="transparent"
                  strokeWidth={strokeWidth}
                  strokeDasharray={strokeDasharray}
                  strokeDashoffset={strokeDashoffset}
                  strokeLinecap="round"
                  r={normalizedRadius}
                  cx={radius}
                  cy={radius}
                />
              );
            })}
          </svg>

          {/* Center */}
          <div className="absolute flex h-36 w-36 flex-col items-center justify-center rounded-full border border-[#F3F4F6] bg-white shadow-inner">
            <span className="mb-1 text-sm text-[#6B7280]">Total COD</span>

            <span className="text-4xl font-bold text-[#111827]">
              {total.toLocaleString()}
            </span>
          </div>
        </div>

        {/* Legend */}
        <div className="w-full space-y-4">
          {data.map((item, index) => (
            <div
              key={index}
              className="flex items-center justify-between rounded-2xl border border-[#F3F4F6] bg-[#FAFAFA] px-4 py-3 transition-all duration-200 hover:bg-[#F4F4F5]"
            >
              <div className="flex items-center gap-3 overflow-hidden">
                <div
                  className="h-3 w-3 rounded-full"
                  style={{
                    backgroundColor: item.color,
                  }}
                />

                <span className="truncate text-sm font-medium text-[#374151]">
                  {item.label}
                </span>
              </div>

              <span className="text-sm font-bold text-[#111827]">
                {item.value.toLocaleString()}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CodByMarchent;
